import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prjectMgm, auditBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const projectTypeMasterService = createApi({
    reducerPath: 'projectTypeMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['ProjectTypeMaster'],
    endpoints: (builder) => ({
        getAllProjectTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectTypeMasterController.getAllProjectTypeMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getProjectTypeMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectTypeMasterController.getProjectTypeMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        saveProjectTypeMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectTypeMasterController.saveProjectTypeMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateProjectTypeMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectTypeMasterController.updateProjectTypeMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteProjectTypeMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectTypeMasterController.deleteProjectTypeMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllProjectTypeMasterWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectTypeMasterController.getAllProjectTypeMasterWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllProjectTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectTypeMasterController.findAllProjectTypeMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllProjectTypeMasterMutation,
    useSaveProjectTypeMasterMutation,
    useUpdateProjectTypeMasterMutation,
    useDeleteProjectTypeMasterMutation,
    useGetProjectTypeMasterByIdMutation,
    useGetAllProjectTypeMasterWithSearchMutation,
    useFindAllProjectTypeMasterMutation,
  } = projectTypeMasterService;